import React from "react";
import { Flame } from "lucide-react";
import { FrameAvatar } from "@/components/cosmetics/FrameAvatar";

export const MemberRows = ({ members }) => (
  <section className="space-y-2" data-testid="family-members">
    <h2 className="text-[11px] font-mono uppercase tracking-widest text-tc-muted">Family members</h2>
    <div className="grid gap-3 md:grid-cols-2">
      {members.map((m) => (
        <div key={m.id} className="tc-card p-4 space-y-2 min-w-0" data-testid={`family-member-${m.first_name.toLowerCase()}`}>
          <div className="flex flex-wrap items-baseline justify-between gap-2">
            <div className="font-semibold flex items-center gap-2">
              <FrameAvatar name={m.name} frame={m.frame} size={30} testid={`family-frame-${m.first_name.toLowerCase()}`} />
              <span>{m.name}{m.is_me ? " (you)" : ""}{m.is_parent ? <span className="text-xs text-tc-muted font-normal"> · parent</span> : null}</span>
            </div>
            <div className="text-[11px] font-mono uppercase tracking-widest text-tc-xp">Lv {m.level} · {m.rank}{m.title ? <span className="text-tc-coach"> · {m.title}</span> : null}</div>
          </div>
          <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-tc-sub">
            <span data-testid="family-member-xp">This week: <span className="font-mono text-tc-txt">{m.xp_this_week} XP</span></span>
            <span>Stage {m.stage}</span>
            <span className="flex items-center gap-1"><Flame className="w-3 h-3" /> {m.streak}-day streak</span>
          </div>
          {m.recent_card ? (
            <a href="#family-gallery" className="block rounded-lg border border-white/10 px-3 py-2 text-xs hover:border-white/30 transition-colors" data-testid="family-member-card">
              Latest Call Card: <span className="font-semibold">{m.recent_card.title}</span> · {m.recent_card.call} · {m.recent_card.grade}
            </a>
          ) : <div className="text-xs text-tc-muted">No Call Card yet.</div>}
        </div>
      ))}
    </div>
  </section>
);
